import React,{ useCallback } from 'react';
import styled from '@emotion/styled';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { useLocalization } from "gatsby-theme-i18n";
import IconPackage from 'xiv-fanfes-2021'

import LinkItem from "../../../components/LinkItem";

const displayLimit = 5;

const Pagination = ({ section, pageInfo, path }) => {
  const { currentPage, hasNextPage, hasPreviousPage, pageCount}  = pageInfo;
  

  const renderPaging = useCallback(() => {
    var elem = []
    for(var i=1; i<= pageCount; i++)
    {
      if((pageCount <= displayLimit) || (currentPage <= displayLimit / 2 && i <= displayLimit) || currentPage == i ||  (i > currentPage - displayLimit / 2 && i <= currentPage + displayLimit / 2 ) || (currentPage > pageCount - (displayLimit / 2) && i > pageCount - displayLimit))
        elem.push(<Pager key={`pager_${i}`} section={section} i={i} active={i===currentPage} path={path}>{i}</Pager>);
      
    }

    return elem;
  },[pageCount,currentPage,section])

  if(pageCount < 2)
  {
    return(<div></div>)
  }

  return (
  <PaginationWrapper>
    <Pager section={section} disabled={!hasPreviousPage} i={currentPage-1} active={false} path={path}>
      <LeftArrow type={"Arrow"} />
    </Pager>
    {(pageCount > displayLimit && currentPage > Math.ceil(displayLimit / 2)) &&
      <Ellipsis>...</Ellipsis>
    }
    {renderPaging()}
    {(pageCount > displayLimit && currentPage < pageCount - (displayLimit / 2)) &&
      <Ellipsis>...</Ellipsis>
    }
    <Pager section={section} disabled={!hasNextPage} i={currentPage+1} active={false} path={path}>
      <RightArrow type={"Arrow"} />
    </Pager>
  </PaginationWrapper>);
}
 
export default Pagination;


const Item = (props) => {
  const { section, i, active, className, disabled, children, path } = props;
  const { currentLocaleObj } = useLocalization();

  if(active)
    return (<span {...props} className={`${className} current`} >{children}</span>);
  
  if(disabled)
    return (<span {...props} className={`${className} disabled`} >{children}</span>);

    return(<LinkItem fade to={`/${currentLocaleObj.prefix}/activity/${path}${section ? `/${section}` : ``}/${i}`} key={`pager_${i}`} {...props}>{children}</LinkItem>)
}

const PaginationWrapper = styled.div`
  text-align:center;
  padding-top:48px;
`

const LeftArrow = styled(IconPackage.Icon)`
  width:32px;
  height:32px;
  transform:rotate(180deg);
  @media only screen and (max-width: ${breakpoint.smMax}){
    width: 24px;
    height: 24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width: 16px;
    height: 16px;
  }
`

const RightArrow = styled(IconPackage.Icon)`
  width:32px;
  height:32px;
  @media only screen and (max-width: ${breakpoint.smMax}){
    width: 24px;
    height: 24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width: 16px;
    height: 16px;
  }
`

const Ellipsis = styled.span`
  display:inline-block;
  font-size: 20px;
  line-height: 32px;
  vertical-align: middle;
  width: 48px;
  height: 48px;
`

const Pager = styled(Item)`
  display:inline-block;
  text-align:center;
  margin:0 8px;
  text-decoration:none;
  background: #FCFCFF;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 3px;
  width: 48px;
  height: 48px;
  font-size: 20px;
  line-height: 32px;
  font-weight: 900;
  padding:8px;
  color: #4E4E50;
  vertical-align:top;

  &:hover:not(.current),&:hover:not(.disabled){
    box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  }

  &:active:not(.current),&:active:not(.disabled){
    background: #ECECEF;
    box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  }

  &.current{
    background: #4E4E50;
    color: #FCFCFF;
  }

  &.disabled{
    background: #F7F7FA;
    box-shadow: none;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width: 40px;
    height: 40px;
    margin:0 6px 12px;
    font-size: 16px;
    line-height: 24px;
    padding:8px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width: 24px;
    height: 24px;
    margin:0 4px 8px;
    font-size: 12px;
    line-height: 16px;
    padding:4px;
  }
`
